<ng-container *ngIf="!isLoadingView; else tplNoData">
  <ng-container *ngIf="canDisplayGrille(); else tplNoRepas">

    <div id="accordion">
      <dx-accordion
        *ngIf="isPointDeLivraisonFirst()"
        [dataSource]="pointsDeLivraison"
        [collapsible]="true"
        [multiple]="true"
        [animationDuration]="300"
        [selectedItems]="pointsDeLivraison"
      >
        <div *dxTemplate="let item of 'title'">
          <h6>{{ item.plc.label }} > {{ item.prestation.libelle }}</h6>
        </div>
        <div class="overflow-auto" *dxTemplate="let item of 'item'">
          <yo-plc-repas [plc]="item.plc" [cols]="cols" [repas]="item.repas" [prestation]="item.prestation"
                        [datesDetailsFromMenu]="datesDetailsFromMenu" [typeEffectif]="typeEffectif"></yo-plc-repas>
        </div>
      </dx-accordion>

      <dx-accordion
        *ngIf="!isPointDeLivraisonFirst()"
        [dataSource]="repas"
        [collapsible]="true"
        [multiple]="true"
        [animationDuration]="300"
        [selectedItems]="repas"
      >
        <div *dxTemplate="let item of 'title'">
          <h6>{{ item.repas.libelle }} > {{ item.prestation.libelle }}</h6>
        </div>
        <div class="overflow-auto" *dxTemplate="let item of 'item'">
          <yo-repas-plc [pointsLivraison]="item.pointsLivraison" [cols]="cols" [repas]="item.repas" [prestation]="item.prestation"
                        [datesDetailsFromMenu]="datesDetailsFromMenu" [typeEffectif]="typeEffectif"></yo-repas-plc>
        </div>
      </dx-accordion>
    </div>

  </ng-container>
</ng-container>

<ng-template #tplNoRepas>
  <div class="mt-4 mb-4">
    <i class="mg-r-5 fas fa-exclamation-triangle danger-color"></i>Aucun menu existant pour cette période.
  </div>
</ng-template>

<ng-template #tplNoData>
  <div class="indicators">
    <dx-load-indicator
      id="large-indicator"
      height="60"
      width="60"
    ></dx-load-indicator>
  </div>
</ng-template>
